module.exports = __webpack_public_path__ + "static/media/test1_1.9472d68a.png";